<template>
  <div class="content-middle">
    <div class="cont-con clearfix">
      <div class="cont-left  hidden-xs">
        <div class="contl-header">
          音频口高频小精灵
          <button class="menu-button" id="open-button">Open Menu</button>
        </div>
        <div class="menu-wrap">
          <nav class="menu">
            <div class="icon-list">
              <router-link
                :to="{path: list.url, query: {index: index}}"
                :class="{'current': currentIndex == index}"
                v-for="(list, index) in lists"
                v-bind:key="index"
              >{{list.text}}</router-link>
            </div>
          </nav>
          <button class="close-button" id="close-button">Close Menu</button>
        </div>
      </div>
      <div class="cont-right">
        <div class="contr-header clearfix">
          <h4>{{rhname}}</h4>
          <div class="contr-nav">
            <router-link to="/">首页</router-link>&gt;
            <router-link :to="{path:'/RH',query: {index: 0}}">音频口高频小精灵</router-link>
            &gt; {{rhname}}
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.rhname = this.$route.meta.title;
    this.currentIndex = this.$route.query.index;
  },
  data() {
    return {
      rhname: "RH06",
      currentIndex: 0,
      lists: [
        { text: "RH06", url: "/RH/06" },
        { text: "RH07", url: "/RH/07" },
        { text: "RH21", url: "/RH/21" }
      ]
    };
  },
  methods: {},
  watch: {
    $route(to, from) {
      if (to != undefined) {
        this.currentIndex = to.query.index;
        this.rhname = to.meta.title;
      }
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/RH/RHindex.vue